import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { useTheme } from 'styled-components'
import TestLayout from './TestLayout'

const MainLayout = ({ children }) => {
  const theme = useTheme()
  const antIcon = <LoadingOutlined style={{ fontSize: 24, color: theme.colorRed }} spin />
  return (
    <div style={{ width: '100%' }}>
      <Suspense fallback={<Spin indicator={antIcon} />}>
        <TestLayout>{children}</TestLayout>
      </Suspense>
    </div>
  )
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default MainLayout
